export default "__VITE_ASSET__DM2enJv1__"